import React from "react";
import { Landmark, Shield, Scale } from "lucide-react";

const JURISDICTIONS = [
  { icon: Landmark, label: "High Court of Madras", sub: "Chennai" },
  { icon: Landmark, label: "High Court for the State of Telangana", sub: "Hyderabad" },
  { icon: Landmark, label: "High Court of Kerala", sub: "Kochi (Ernakulam)" },
  { icon: Shield, label: "Armed Forces Tribunal", sub: "Chennai & Regional Benches" },
  { icon: Scale, label: "District, Sessions & Trial Courts", sub: "Pan-India representation" },
  { icon: Scale, label: "Specialised Tribunals & Quasi-judicial Fora", sub: "As briefed" },
];

export default function Jurisdictions() {
  return (
    <section
      data-testid="jurisdictions-section"
      className="section"
      style={{ backgroundColor: "#FFFFFF", borderTop: "1px solid #E2DCD0" }}
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end mb-16">
          <div className="md:col-span-7">
            <span className="ornament text-xs" style={{ letterSpacing: "0.28em", textTransform: "uppercase" }}>
              Where We Appear
            </span>
            <h2
              className="font-serif-display mt-6 text-4xl md:text-5xl"
              style={{ color: "#0A1128", fontWeight: 500, lineHeight: 1.1 }}
            >
              Counsel across three
              <br />
              <span style={{ fontStyle: "italic", color: "#7A2021" }}>
                High Courts &amp; the Tribunals.
              </span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-base md:text-lg" style={{ color: "#334155", lineHeight: 1.7 }}>
              The practice appears regularly before the High Courts of Madras, Telangana
              and Kerala; the Armed Forces Tribunals; and a wide range of subordinate
              courts and specialised tribunals across India.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px"
          style={{ backgroundColor: "#E2DCD0", border: "1px solid #E2DCD0" }}
        >
          {JURISDICTIONS.map((j) => {
            const Icon = j.icon;
            return (
              <div
                key={j.label}
                className="p-7 flex flex-col gap-3"
                style={{ backgroundColor: "#FFFFFF" }}
                data-testid={`jurisdiction-${j.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <Icon size={22} strokeWidth={1.4} style={{ color: "#7A2021" }} />
                <div className="font-serif-display text-xl md:text-2xl" style={{ color: "#0A1128", fontWeight: 500, lineHeight: 1.2 }}>
                  {j.label}
                </div>
                <div className="text-[11px] uppercase" style={{ color: "#64748B", letterSpacing: "0.22em" }}>
                  {j.sub}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
